import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
import {
  // FormFeedback,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  // Toast,
  // ToastBody,
  // ToastHeader,
} from "reactstrap";
import { object, string } from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
import { useFormik } from "formik";
import ToastHandler from "../../../components/Common/ToastHandler";
import Axios from "../../../lib/Axios";
// import { AxiosError } from "axios";

const schema = object({
  schoolName: string().required("school name is required"),
});

const SchoolFormBody = ({ data, setSchoolData, refetch }) => {
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm({
  //   resolver: yupResolver(schema),
  // });

  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  async function onSubmit(formData) {
    try {
      const dt = data
        ? {
            ...formData,
            schoolId: data.schoolId,
            isVerified: true,
          }
        : {
            ...formData,
            isVerified: true,
          };

      const result = data
        ? await Axios.post("/cms/cms-edit/school", dt)
        : await Axios.post("/cms/cms-set/school", dt);
      console.group(result.data);
      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      schoolName: data ? data?.schoolName : "",
    },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    return () => {
      if (data) {
        setSchoolData(null);
      }
    };
  }, [data, setSchoolData]);

  return (
    <>
      <form className="tablelist-form" onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom01">School name</Label>
              <Input
                placeholder="School name"
                type="text"
                className="form-control"
                id="schoolName"
                name="schoolName"
                value={formik.values.schoolName}
                onChange={formik.handleChange}
              />

              {formik.touched.schoolName && formik.errors.schoolName && (
                <div className="error">{formik.errors.schoolName}</div>
              )}
            </FormGroup>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            {/* <button
            type="button"
            className="btn btn-light"
            // onClick={() => setmodal_list(false)}
          >
            Close
          </button> */}
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-success"
            >
              {formik.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default SchoolFormBody;
